var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("BarreActions", {
        attrs: { actions: _vm.actions },
        on: {
          "appliquer-action": function($event) {
            return _vm.executerAction($event)
          }
        }
      }),
      _c("div", { staticClass: "card height-responsive" }, [
        _c("div", { staticClass: "card-header flex-center-space-between" }, [
          _c("div", { staticClass: "flex-start" }, [
            _c("span", [_vm._v(_vm._s(_vm.nomRecette))])
          ])
        ]),
        _c(
          "div",
          {
            staticClass: "card-body height-responsive-body height-responsive-1b"
          },
          [
            _c("RecetteEdition", {
              ref: "recetteEdition",
              attrs: {
                recetteId: _vm.recetteId,
                enAjout: _vm.enAjout,
                enDuplication: _vm.enDuplication,
                lienRecetteActif: true
              },
              on: {
                "recette-initialisee": function($event) {
                  return _vm.recetteInitialisee($event)
                },
                "recette-modifiee": function($event) {
                  return _vm.recetteModifiee($event)
                },
                "recette-changee": function($event) {
                  return _vm.recetteChangee($event)
                }
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }